import { render } from "./DisplayOnlyTheLastLevel.vue?vue&type=template&id=2e58333b"
import script from "./DisplayOnlyTheLastLevel.vue?vue&type=script&lang=js"
export * from "./DisplayOnlyTheLastLevel.vue?vue&type=script&lang=js"
script.render = render

export default script